"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshShopItemButtons = exports.OnItemBuyClick = exports.CanBuyItem = exports.RefreshShopItem = exports.BuildShop = void 0;
var enums_1 = require("./enums");
var lib_1 = require("./lib/lib");
var data_1 = require("./data");
var rendering_1 = require("./rendering");
var time_1 = require("./lib/time");
var math_1 = require("./lib/math");
var rewardedPopup_1 = require("./rewardedPopup");
var builders_1 = require("./builders");
var _1 = require(".");
var shopItem = function (id, name, imageName, tab, hasProgressBar, progressBarDuration) { return "\n    <div id=\"".concat(id, "\" class=\"item shop-tab-").concat(tab, "\">\n        <div class=\"name mobile\">").concat(name, "</div>\n        <div class=\"image-container\">\n          <img class=\"image main\" src=\"./img/items/").concat(imageName, "\"/>\n          <img class=\"image locked\" src=\"./img/question.png\"/>\n          ").concat(hasProgressBar
    ? "<div class=\"progress-bar\"><div class=\"fill\" style=\"animation-duration: ".concat(progressBarDuration, "s\"></div></div>")
    : "", "\n        </div>\n        <div class=\"locked-text\">?????</div>\n        <div>\n          <div class=\"name pc\">").concat(name, "</div>\n          <div class=\"value\"></div>\n        </div>\n        <div class=\"fill-space\"></div>\n        <div class=\"button\"></div>\n    </div>\n"); };
var BuildShop = function () {
    var shopContainerElement = document.querySelector("#shop .container");
    document.querySelector("#tab-0").addEventListener("click", function () { return OnTabSelect(0); });
    document.querySelector("#tab-1").addEventListener("click", function () { return OnTabSelect(1); });
    Object.values(enums_1.ITEM).forEach(function (upgradeKey) {
        var item = data_1.Items[upgradeKey];
        var tab = 1;
        var hasProgressBar = false;
        var progressBarDuration = 0;
        if (data_1.Builders.includes(upgradeKey)) {
            tab = 0;
            hasProgressBar = true;
            progressBarDuration = item.intervalSeconds;
        }
        shopContainerElement.innerHTML += shopItem(upgradeKey, item.name, item.imageName, tab, hasProgressBar, progressBarDuration);
    });
    setTimeout(function () {
        Object.values(enums_1.ITEM).forEach(function (upgradeKey) {
            document.querySelector("#".concat(upgradeKey, " .button")).addEventListener("click", function () {
                (0, exports.OnItemBuyClick)(upgradeKey);
            });
            (0, exports.RefreshShopItem)(upgradeKey);
        });
        OnTabSelect(0);
    }, 1);
};
exports.BuildShop = BuildShop;
var RefreshShopItem = function (item) {
    document.querySelector("#".concat(item, " .button")).innerHTML = "$".concat((0, math_1.FormatNumber)((0, lib_1.CalcItemPrice)(item)));
    SetItemButtonActive(item);
    var value = "No value!!!";
    switch (item) {
        case enums_1.ITEM.BricksPerClick:
            value = "".concat((0, lib_1.CalcBricksPerClick)(), " brick").concat((0, lib_1.CalcBricksPerClick)() !== 1 ? "s" : "");
            if (rewardedPopup_1.PremiumIsActive) {
                value += " <span class=\"x2-reward\">x2</span>";
            }
            break;
        case enums_1.ITEM.MoneyPerBrick:
            value = "<span class=\"dollar-sign\">$</span>".concat((0, lib_1.CalcMoneyPerBrick)());
            if (rewardedPopup_1.PremiumIsActive) {
                value += " <span class=\"x2-reward\">x2</span>";
            }
            break;
        case enums_1.ITEM.HouseSize:
            value = "".concat(data_1.HouseData.xBlocks * data_1.HouseData.yBlocks, " blocks");
            break;
        case enums_1.ITEM.Bank:
            value = "max <span class=\"dollar-sign\">$</span>".concat((0, math_1.FormatNumber)((0, lib_1.CalcOfflineIncomeData)().maxMoney), " offline");
            break;
        case enums_1.ITEM.Banker:
            value = "max ".concat((0, time_1.msToHHMM)((0, lib_1.CalcOfflineIncomeData)().maxTimeMs), "h offline");
            break;
    }
    if (data_1.Builders.includes(item)) {
        var builderLevel = data_1.GameData.itemLevel[item];
        value = "".concat(builderLevel, " brick").concat(builderLevel === 1 ? "" : "s", "/").concat(data_1.Items[item].intervalSeconds, "s");
        // builders are locked until they are purchased
        document.querySelector("#".concat(item)).classList.toggle("locked", data_1.GameData.itemLevel[item] === 0);
    }
    document.querySelector("#".concat(item, " .value")).innerHTML = value;
};
exports.RefreshShopItem = RefreshShopItem;
var SetItemButtonActive = function (item) {
    document.querySelector("#".concat(item, " .button")).classList.toggle("disabled", !(0, exports.CanBuyItem)(item));
};
var CanBuyItem = function (item) {
    var price = (0, lib_1.CalcItemPrice)(item);
    return price <= data_1.GameData.money;
};
exports.CanBuyItem = CanBuyItem;
var OnItemBuyClick = function (item) {
    if (!(0, exports.CanBuyItem)(item)) {
        return;
    }
    var price = (0, lib_1.CalcItemPrice)(item);
    data_1.GameData.money -= price;
    data_1.GameData.itemLevel[item]++;
    (0, exports.RefreshShopItem)(item);
    (0, exports.RefreshShopItemButtons)();
    (0, data_1.SaveGameData)();
    (0, _1.UpdateMoneyText)();
    if (data_1.Builders.includes(item)) {
        (0, builders_1.StartBuilders)();
    }
    switch (item) {
        case enums_1.ITEM.HouseSize:
            (0, data_1.RefreshHouseData)();
            (0, rendering_1.RenderFromScratch)();
            (0, exports.RefreshShopItem)(enums_1.ITEM.HouseSize);
            break;
    }
};
exports.OnItemBuyClick = OnItemBuyClick;
var OnTabSelect = function (tab) {
    document.querySelectorAll(".tab").forEach(function (e) { return e.classList.remove("active"); });
    document.querySelector("#tab-" + tab).classList.add("active");
    document.querySelectorAll(".item").forEach(function (e) { return (e.style.display = "none"); });
    document.querySelectorAll(".shop-tab-" + tab).forEach(function (e) { return (e.style.display = ""); });
};
var RefreshShopItemButtons = function () { return Object.values(enums_1.ITEM).forEach(function (item) { return SetItemButtonActive(item); }); };
exports.RefreshShopItemButtons = RefreshShopItemButtons;
